/**
 * Builds URLs for the cio-editors embedded in library-website (iframe, window open)
 * Appends the region's content-server origin as `contentServerUrl` so the editor
 * talks to the correct regional content-server.
 *
 * The region is decoded from the asset id when present (regionFromId)
 * For new assets (no id) it defaults to the active region.
 * The editor host URLs themselves are NOT regional, only the content-server differs by region.
 * Tenant is constant across regions, so passing the origin only (cio-editors appends its own
 * tenant) is sufficient.
 */

const RegionUtil = require("./RegionUtil.js")

// base : editor host URL (e.g. ApplicationContext.getPackageEditor())
function editorUrl(base, options) {
    const {id, version, mode, hub} = options || {}
    const origin = id
        ? RegionUtil.getRegionServer(RegionUtil.regionFromId(id))
        : RegionUtil.getRegionServer()

    const params = new URLSearchParams()

    const url = new URL(base)
    if (id) url.searchParams.set("assetid", id)
    if (version && version !== -1) url.searchParams.set("version", version)
    if (mode) url.searchParams.set("mode", mode)
    if (hub) url.searchParams.set("hub", hub)

    if (origin) url.hash = base64UrlEncode(origin)

    return url.href
}

function base64UrlEncode(data) {
    return btoa(data)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '')
}

module.exports = { editorUrl }
